import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Cacheable } from 'ts-cacheable';

import { ApiService } from '../../core/api';
import { AuthService } from '../../core/auth';
import { ChargingLocationFullApp, ChargingLocationMinimalApp } from '../locations';

import { GetNearestStationsParams } from './types';

@Injectable({
  providedIn: 'root'
})
export class ChargingStationsService {
  constructor(private readonly apiService: ApiService) {}

  @Cacheable({
    cacheBusterObserver: AuthService.cacheBuster$,
    maxAge: 1_800_000
  })
  getChargingStation(stationID: number, appToken = null): Observable<ChargingLocationFullApp> {
    return this.apiService.get<ChargingLocationFullApp>(`ChargingStations/${stationID}/${appToken}`);
  }

  getNearestStations(
    customerID: number,
    limit: number,
    lat: number,
    lon: number,
    range: number,
    startIndex = 0,
    loadBoxes = false,
    minKWh = 0,
    maxKWh = 1000,
    includeExternalStations = false,
    cTypes = '',
    appToken = null,
    params: GetNearestStationsParams
  ): Observable<ChargingLocationMinimalApp[]> {
    const url = `ChargingStations/ForCustomer/${customerID}/${limit}/${lat}/${lon}/${range}/${startIndex}/${loadBoxes}/${minKWh}/${maxKWh}/${includeExternalStations}/${cTypes}/${appToken}`;

    if (customerID > 0) {
      return this.apiService.get<ChargingLocationMinimalApp[]>(url, { params });
    }

    return this.apiService.getUnsecure<ChargingLocationMinimalApp[]>(url, { params });
  }
}
